// Libs
import React from 'react';
import styled from 'styled-components';
import { I18n } from '@aws-amplify/core';

// Images
import arrowIcon from '../assets/images/arrow-yellow.svg';

// Styles
const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10rem 0 2rem;
  background: #22254B4B;

  @media (max-width: 480px) {
    padding-top: 4rem;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  max-width: 1260px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Title = styled.h1`
  margin: 0 auto 3rem;
  font: 500 3.4375rem 'Rois', sans-serif;
  color: #FFCE06;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const IqualTitle = styled.span`
  margin: 0 1rem;

  @media (max-width: 480px) {
    margin: 0 0 -.25rem;
    display: block;
  }
`;

const SubTitle = styled.h2`
  width: 75%;
  margin: 0 auto;
  color: #22254B;
  text-align: center;
  font: 400 1.5625rem 'Paralucent', sans-serif;

  @media (max-width: 480px) {
    width: 85%;
    font-size: 1.375rem;
  }
`;

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  width: 65%;
  margin: 3rem auto 0;

  @media (max-width: 768px) {
    width: calc(100% - 80px);
  }

  @media (max-width: 480px) {
    flex-direction: column;
    width: 85%;
  }
`;

const Text = styled.p`
  width: calc(50% - 1.75rem);
  color: #22254B;
  font: 400 .9375rem 'Soleto', sans-serif;
  letter-spacing: .33px;
  line-height: 1.375rem;
  text-align: justify;

  @media (max-width: 480px) {
    width: 100%;
    margin: 0;
    font-size: .875rem;
  }
`;

const ButtonScroll = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5rem auto 0;
  padding: 0;
  border: none;
  background-color: transparent;
  font: 400 1.5625rem 'Paralucent', sans-serif;
  color: #FFCE06;
  text-transform: uppercase;
  cursor: pointer;
  outline: none;

  @media (max-width: 480px) {
    margin-top: 3rem;
  }
`;

const ButtonIcon = styled.img`
  width: 1rem;
  margin-bottom: 1rem;
`;

const dict = {
  en: {
    'faq-subtitle': 'The way organizations approach business strategy is changing rapidly, becoming dynamic, interactive and collective.',
    'faq-description-one': 'The agile revolution brings the individual and collaboration as the central focus of organizations that seek the sustainability of their business through innovation.',
    'faq-description-two': 'Strytegy is the ideal tool for all those who need a digital space to create and prototype new ideas in an agile way and improve their results.',
  },
  'pt-BR': {
    'faq-subtitle': 'A forma como as organizações estão conduzindo seus processos está mudando rapidamente, tornando-se mais dinâmica, interativa e coletiva.',
    'faq-description-one': 'A revolução ágil traz o indivíduo e a colaboração como foco central das organizações que buscam, por meio da inovação, a sustentabilidade de seus negócios. ',
    'faq-description-two': 'O Strytegy é a ferramenta ideal para todos aqueles que precisam de um espaço digital para criar e prototipar novas ideias, de maneira ágil, com foco em resultados.',
  },
};

const FaqIntro = ({
  language,
  isMobile
}) => {
  I18n.setLanguage(language === 'pt-BR' ? 'pt-BR' : 'en');
  I18n.putVocabularies(dict);

  const handleDisplayList = () => {
    document.querySelector('#faq-list').scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: "nearest",
      top: 500
    });
  }

  return (
    <Container>
      <Wrapper>
        <Title>
          Strategy + Try
          <IqualTitle>
            =
          </IqualTitle>
          Strytegy
        </Title>
        <SubTitle>{I18n.get('faq-subtitle')}</SubTitle>
        <Info>
          <Text>{I18n.get('faq-description-one')}</Text>
          <Text>{I18n.get('faq-description-two')}</Text>
        </Info>
        <ButtonScroll
          onClick={handleDisplayList}
        >
          <ButtonIcon src={arrowIcon} alt='arrow icon' />
          faq
        </ButtonScroll>
      </Wrapper>
    </Container>
  );
}

export default FaqIntro;
